import { render, staticRenderFns } from "./ListOpd.vue?vue&type=template&id=19265953&scoped=true"
import script from "./ListOpd.vue?vue&type=script&lang=js"
export * from "./ListOpd.vue?vue&type=script&lang=js"
import style0 from "./ListOpd.vue?vue&type=style&index=0&id=19265953&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19265953",
  null
  
)

export default component.exports